module.exports = __webpack_public_path__ + "img/softgrove-5.bc2aa575.jpeg";